/** Auth 關閉或尚無 user 時，供帳號選單／個人頁預覽用。 */
export const ACCOUNT_PROFILE_MOCK = {
  name: '開發預覽',
  account: 'dev-preview',
  displayName: '開發預覽',
  nickname: '—',
  workEmail: '—',
  title: '職稱（預覽）',
  avatarUrl: null,
};

function getInitials(name) {
  const trimmed = String(name || '').trim();
  if (!trimmed) return '?';
  if (/[\u4e00-\u9fff]/.test(trimmed[0])) return trimmed[0];
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
  }
  return trimmed.slice(0, 2).toUpperCase();
}

function formatRolesTitle(roles) {
  if (!Array.isArray(roles) || roles.length === 0) {
    return '—';
  }
  const names = roles
    .map((role) => (role?.name != null ? String(role.name).trim() : ''))
    .filter(Boolean);
  return names.length > 0 ? names.join('、') : '—';
}

function pickRawDisplayName(user) {
  const raw = user?.displayName ?? user?.display_name;
  if (raw == null || String(raw).trim() === '') {
    return '';
  }
  return String(raw).trim();
}

function pickRawWorkEmail(user) {
  const raw = user?.workEmail ?? user?.work_email;
  if (raw == null || String(raw).trim() === '') {
    return '';
  }
  return String(raw).trim();
}

/**
 * 從 Redux `user`＋`roles` 解析帳號選單／個人頁顯示欄。
 * - `displayName`：暱稱；缺則 fallback name／account（Nav「您好，…」）
 * - `nickname`：個人頁暱稱列；缺則「—」
 * - `workEmail`：個人頁工作信箱；缺則「—」
 * - `title`：roles[].name 以「、」串接
 * @param {object | null | undefined} user
 * @param {Array<object>} [roles]
 */
export function resolveAccountDisplay(user, roles = []) {
  if (!user) {
    return {
      name: ACCOUNT_PROFILE_MOCK.name,
      account: ACCOUNT_PROFILE_MOCK.account,
      displayName: ACCOUNT_PROFILE_MOCK.displayName,
      nickname: ACCOUNT_PROFILE_MOCK.nickname,
      workEmail: ACCOUNT_PROFILE_MOCK.workEmail,
      title: ACCOUNT_PROFILE_MOCK.title,
      avatarUrl: ACCOUNT_PROFILE_MOCK.avatarUrl,
      initials: getInitials(ACCOUNT_PROFILE_MOCK.name),
      isMock: true,
    };
  }

  const name = user.name || user.account || '帳號';
  const rawNickname = pickRawDisplayName(user);
  const rawWorkEmail = pickRawWorkEmail(user);
  const avatarUrl = user.avatarUrl || user.avatar || null;

  return {
    name,
    account: user.account || '',
    displayName: rawNickname || name,
    nickname: rawNickname || '—',
    workEmail: rawWorkEmail || '—',
    title: formatRolesTitle(roles),
    avatarUrl,
    initials: getInitials(name),
    isMock: false,
  };
}
